import { axiosPlatform } from "../../../_services/axios-helper";

const getAllAccountingTasks = (filterProperties) => {
    return axiosPlatform().get(
        "/downstream/datev/allaccountingsequences" + (filterProperties ? "?" + objToQueryString(filterProperties) : "")
    );
};

const objToQueryString = (obj) => {
    const keyValuePairs = [];
    for (const key in obj) {
        if (obj[key] && obj[key] !== "") {
            keyValuePairs.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]));
        }
    }
    return keyValuePairs.join("&");
};

const deleteAccountingTask = (list) => {
    return axiosPlatform().delete("/downstream/datev/accountingtasks/delete", { data: list });
};

const getAccountingTaskDetails = (externalUUID) => {
    return axiosPlatform().get("/downstream/datev/accountingsequences/" + externalUUID);
};

const exportAccountingTasks = (exportRequest) => {
    return axiosPlatform().post("/downstream/datev/export", exportRequest);
};

const exportDuplicatesForAccountingTask = (exportRequest) => {
    return axiosPlatform().post("/downstream/tasks/revert-duplicates", exportRequest);
};

const compressAccountingTasks = (taskUUIDs) => {
    return axiosPlatform().post("/downstream/datev/compress", taskUUIDs);
};

const getAccountingTaskSummary = (externalUUID) => {
    return axiosPlatform().get("/downstream/datev/accountingsequences/" + externalUUID + "/account-summary");
};

export const accountingTasksService = {
    getAllAccountingTasks,
    deleteAccountingTask,
    getAccountingTaskDetails,
    exportAccountingTasks,
    exportDuplicatesForAccountingTask,
    compressAccountingTasks,
    getAccountingTaskSummary,
};
